import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const VisualizarDadosCompra = ({ values }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          id="codigo"
          label="Identificador"
          value={values?.compraId ? `${values?.compraId}`.padStart(3, '0') : '-'}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <DateLabel
          id="dataCompra"
          label="Data da compra"
          value={values?.dataCompra ? moment(values.dataCompra) : null}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextLabel id="fornecedor" label="Fornecedor" value={values?.fornecedor?.pessoa?.nome} />
      </Grid>
    </Grid>
  );
};

export default VisualizarDadosCompra;
